import { Injectable } from '@angular/core';
import { createCsvBlob } from '@marmon/shared/types/common';
import { downloadFile } from '../utils';

@Injectable({ providedIn: 'root' })
export class FileService {
	downloadCsv(name: string, rows: string[]) {
		const csv = createCsvBlob(rows);
		return downloadFile(csv, name);
	}
}
